import { useEffect, useState } from "react";

interface InstallPrompt extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}
export function InstallApp() {
  const [prompt, setPrompt] = useState<InstallPrompt | null>(null);
  const [installed, setInstalled] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const display = window.matchMedia("(display-mode: standalone)");
    const update = () => setInstalled(display.matches || (navigator as Navigator & { standalone?: boolean }).standalone === true);
    const offered = (event: Event) => { event.preventDefault(); setPrompt(event as InstallPrompt); };
    const complete = () => { setInstalled(true); setPrompt(null); };
    update();
    display.addEventListener("change", update);
    window.addEventListener("beforeinstallprompt", offered);
    window.addEventListener("appinstalled", complete);
    return () => {
      display.removeEventListener("change", update);
      window.removeEventListener("beforeinstallprompt", offered);
      window.removeEventListener("appinstalled", complete);
    };
  }, []);
  if (installed) return <span className="source-header-label">STANDALONE</span>;
  if (prompt) return <button className="pwa-install" disabled={busy} onClick={async () => {
    setBusy(true);
    try { await prompt.prompt(); await prompt.userChoice; }
    catch { /* Fall back to the browser-menu instructions if the prompt expires. */ }
    finally { setPrompt(null); setBusy(false); }
  }}>安装 BASS <span aria-hidden="true">↗</span></button>;
  return <details className="pwa-install-help">
    <summary>安装 BASS <span aria-hidden="true">↗</span></summary>
    <div className="pwa-install-card">
      <img src="/icons/icon-192.png" width="48" height="48" alt="BASS 冰色光管图标" />
      <strong>把光场放到主屏幕</strong>
      <p>iPhone / iPad：在 Safari 点「分享」，选择「添加到主屏幕」，保持「作为网页 App 打开」开启（如有）。</p>
      <p>Android：在浏览器菜单选择「安装应用」或「添加到主屏幕」。</p>
      <span>首次联网打开后，可离线启动。音频留在你的设备上。</span>
    </div>
  </details>;
}
